import { gql } from '@apollo/client';

const categoryFiltersQuery = gql`
    query categoryFilters(
        $language: Language!
        $id: ID!
        $includeValues: Boolean!
    ) {
        category(language: $language, id: $id) {
            key
            id
            filters {
                id
                field
                name
                values @include(if: $includeValues)
                valueLabels @include(if: $includeValues)
            }
        }
    }
`;

export default categoryFiltersQuery;
